import { atom } from "jotai";

interface Metadata {
    speakers: number;
    meta_City: string;
    meta_State: string;
    meta_CompanySize: string;
}

interface Interview {
    owner: string;
    interviewee: string;
    interviewID: string;
    name: string;
    created: string;
    modified: string | null;
    company: string;
    title: string;
    email: string;
    phone: string;
    communication: string;
    userID: string;
    groupID: string;
    templateID: string;
    status: string;
    createdF: string | null;
    type: string | null;
    date: string | null;
    metadata?: Metadata;
    deleted: number;
    username: string;
    photoURL: string;
    speakers: number;
    meta_City: string;
    meta_State: string;
    meta_CompanySize: string;
}

export type InterviewArray = Interview[];
const INITIAL_INTERVIEWS_IN_ATOM_VALUE: InterviewArray = [];
export const interviewsAtom = atom<InterviewArray>(INITIAL_INTERVIEWS_IN_ATOM_VALUE);